// extracted by mini-css-extract-plugin
export default {"loggedInContainer":"LoggedIn_loggedInContainer__wYgla","title":"LoggedIn_title__xYt3p","wordMarkPadding":"LoggedIn_wordMarkPadding__GvRWA","menubar":"LoggedIn_menubar__VvHSs"};